import { query } from '@confluence/query-preloader-tools';

import { FeatureDiscoveryQuery } from './FeatureDiscoveryQuery.graphql';

export function preloadFeatureDiscovery() {
	return query({
		query: FeatureDiscoveryQuery,
	});
}
